export default __webpack_public_path__ + "static/media/taxIcon.13d1d7c5.svg";